import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material/form-field';
import { TimeComponent } from '../../../time/time.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-time-type',
  template: `
  <div [id]="field.id">
    <app-time 

      
      [formControl]="formControl"
      [formlyAttributes]="field"      
      [tabIndex]="to.tabindex"
    

      ></app-time>
      <ng-template #matPrefix>
        <mat-icon style="    transform: translateY(3px); " >schedule</mat-icon> 
      </ng-template>
    </div>
    
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TimeComponent,
    ReactiveFormsModule, FormlyModule, MatIconModule
  ]
})
export class TimeTypeComponent extends FieldType<FieldTypeConfig> {

}
